import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function ConfirmationModal({ open, handleClose }: { open: boolean, handleClose: (close: boolean) => void }) {
  return (
    <>
      <BootstrapDialog
        fullWidth
        onClose={()=> handleClose(false)}
        aria-labelledby="confirmation-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="confirmation-dialog-title">
        Would you like to save this record?
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={()=> handleClose(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 12,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
          This action cannot be undone after saving.
          </Typography>
        </DialogContent>
        <DialogActions sx={{'&.MuiDialogActions-spacing':{p: 2}}}>
          <Button variant='contained' color='inherit' onClick={() => handleClose(false)}>Cancel</Button>
          <Button variant='contained' color='primary' onClick={() => handleClose(true)} autoFocus>
            Update
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}
